const $ = require('jquery');
const _ = require("underscore");
import run from '../../utilities/run';
import render from "../../utilities/render";
import {setElementsFromScope} from "../../utilities/selectorHelpers";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";
import {isTruthy, isFalsey} from "../../utilities/general";
const modalHtml = require('../../sharedHtml/modal.html');
const cancelAppointmentModalBodyHtml = require('./html/cancelAppointmentModalBody.html');
const targetSelector = "#appointment-details";

run(targetSelector, (el)=>{
  const mainEl = $(el);
  const els = {};
  let cancelAppointmentModal;
  const modalOpts = { backdrop: 'static', show: false };
  const cancelReasons = el.data("cancel-reasons");
  const appointment = el.data("appointment");
  const editAppointmentUrl = el.data("edit-appointment-url");
  const cancelAppointmentUrl = el.data("cancel-appointment-url");
  const elementsMap = {
    cancelBtn: ".cancel-appointment-btn",
    modalCancelBtn: ".cancel-appointment-btn-on-modal",
    cancelReasonSelect: "#cancel-reason-select",
    cancelNotes: "#cancel-notes",
    pencilIcon: ".fa-pencil",
    editBtn: ".app-edit-btn"
  };

  init();
  const submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();


  function init() {
    generateModal();
    setElements();
    loadCancelReasons();
    showHideButtons();
  }

  function generateModal() {
    cancelAppointmentModal = $(render(
      modalHtml, {
        title: 'Cancel Appointment',
        modalDialogClass: 'q-modal-dialog-800',
        leftAlignTitle: true,
        topCloseBtn: true,
        autoHideTop: true,
        body: cancelAppointmentModalBodyHtml,
        footerBtns: `
                    <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a>
                    <a href="#" class="base-btn purple-btn cancel-appointment-btn-on-modal">Cancel Appointment</a>
                  `
      }
    ));

    mainEl.append(cancelAppointmentModal);
    cancelAppointmentModal.modal(modalOpts);
  }

  function setElements() {
    setElementsFromScope(els, elementsMap, el);
  }


  function loadCancelReasons() {
    _.each(cancelReasons, function(data){
      const option = $('<option />');
      option.attr('value', data.cdmValue).text(data.cdmMeaning);
      els.cancelReasonSelect.append(option);      
    });
  }

  function showHideButtons() {
    let status = appointment.status;
    let hasMultipleRetailers = appointment.hasMultipleRetailers;
    let isFacilityUser = appointment.isFacilityUser;
    if((isFalsey(isFacilityUser) && isTruthy(hasMultipleRetailers)) ||
          status !== "Scheduled") {
      els.editBtn.hide();
      els.cancelBtn.hide();
      els.pencilIcon.addClass("disabled");
    }
    els.modalCancelBtn.attr("disabled", true);
  }

  els.cancelBtn.on("click", showCancelAppointmentModal);
  els.modalCancelBtn.on("click", cancelAppointment);
  els.editBtn.on("click", editAppointment);
  els.pencilIcon.on("click", onClickPencil);
  els.cancelReasonSelect.on("change", onChangeCancelReason);

  function showCancelAppointmentModal(e) {
    e.preventDefault();
    cancelAppointmentModal.modal('show');
  }

  function cancelAppointment() {
    cancelAppointmentModal.modal('hide');
    submitModalFlow.showLoadingModal(); 
    $.ajax({
      url: cancelAppointmentUrl,
      type: "POST",
      data: {
        [`cancelReason`]: els.cancelReasonSelect.val(),
        [`cancelNotes`]: els.cancelNotes.val()
      },
      success: onCancelSuccess,
      error: onCancelError
    }); 
  }

  function onCancelSuccess(data) {
    submitModalFlow.hideAllModals();
    if(data.match("success")) {
      submitModalFlow.showSuccessModal();
      setTimeout(function() { 
        location.reload();
      }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
    } else {
      submitModalFlow.showFailureModal();
    }
  }

  function onCancelError() {
    submitModalFlow.hideAllModals();
    submitModalFlow.showFailureModal();
  }

  function onClickPencil() {
    if(!els.pencilIcon.hasClass("disabled")) {
      editAppointment();
    }
  }

  function onChangeCancelReason() {
     els.modalCancelBtn.attr("disabled", false);
  }

  function editAppointment() {
    location.href = editAppointmentUrl;
  }

});


// WEBPACK FOOTER //
// ./src/pages/appointmentForm/details.js